import { useToast } from '@chakra-ui/react';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useHistory } from 'react-router-dom';
import {
  getDiscounts,
  getExtensionProposalContract,
  getNotExtendingReasons,
} from '~/services/Extensions';
import { SelectItem } from '~/types';
import { DefaultDiscountVIew } from '~/types/discount';
import { ContractExtensionProposal } from '~/types/extensionProposal';

export function useExtensionDiscounts(
  query: string,
  options: UseQueryOptions<DefaultDiscountVIew[], unknown> = {},
): UseQueryResult<DefaultDiscountVIew[]> {
  return useQuery<DefaultDiscountVIew[], unknown>(
    ['extension-discounts', query],
    () => getDiscounts(query),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useNotExtendingReasons(
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[]> {
  return useQuery<SelectItem[], unknown>(
    ['not-extending-reasons'],
    () => getNotExtendingReasons(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useContractExtensionProposal(
  idContrato: string,
  options: UseQueryOptions<ContractExtensionProposal, unknown> = {},
): UseQueryResult<ContractExtensionProposal> {
  const toast = useToast();
  const history = useHistory();

  return useQuery<ContractExtensionProposal, unknown>(
    ['extensionProposal', idContrato],
    () => getExtensionProposalContract(idContrato),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro buscar detalhes do contrato',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        history.goBack();
      },
    },
  );
}
